import React from "react";

export const DownloadIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 469.333 469.333"
  >
    <g>
      <g>
        <g>
          <path
            d="M467.646,260.896l-96-149.333c-1.979-3.052-5.354-4.896-8.979-4.896h-85.333c-5.896,0-10.667,4.771-10.667,10.667
           c0,5.896,4.771,10.667,10.667,10.667h79.5l82.293,128h-65.793c-23.521,0-42.667,19.135-42.667,42.667
           c0,11.76-9.563,21.333-21.333,21.333H160c-11.771,0-21.333-9.573-21.333-21.333C138.667,275.135,119.521,256,96,256H30.207
           L112.5,128H192c5.896,0,10.667-4.771,10.667-10.667c0-5.896-4.771-10.667-10.667-10.667h-85.333c-3.625,0-7,1.844-8.979,4.896
           l-96,149.333C0.583,262.615,0,264.625,0,266.667v160c0,23.531,19.146,42.667,42.667,42.667h384
           c23.521,0,42.667-19.135,42.667-42.667v-160C469.333,264.625,468.75,262.615,467.646,260.896z M448,426.667
           c0,11.76-9.563,21.333-21.333,21.333h-384c-11.771,0-21.333-9.573-21.333-21.333V277.333H96c11.771,0,21.333,9.573,21.333,21.333
           c0,23.531,19.146,42.667,42.667,42.667h149.333c23.521,0,42.667-19.135,42.667-42.667c0-11.76,9.563-21.333,21.333-21.333H448
           V426.667z"
          />
          <path
            d="M163.125,195.125c-4.167,4.167-4.167,10.917,0,15.083l64,64c2.083,2.083,4.813,3.125,7.542,3.125
           s5.458-1.042,7.542-3.125l64-64c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-45.792,45.792V10.667
           C245.333,4.771,240.562,0,234.667,0S224,4.771,224,10.667v230.25l-45.792-45.792
           C174.042,190.958,167.292,190.958,163.125,195.125z"
          />
        </g>
      </g>
    </g>
  </svg>
);
